module.exports = __webpack_public_path__ + "img/logo-mini.f699fc55.png";